<template>
  <UiDialog
    :model-value="modelValue"
    width="485px"
    @update:model-value="$emit('update:modelValue', $event)"
    class="help-hide-confirm__dialog"
   data-testid="components-help-popover-help-hide-confirm-modal-ui-dialog">
    <div class="help-hide-confirm" data-testid="components-help-popover-help-hide-confirm-modal-div">
      <ModalHeader
        :title="t('help_popover.hide_confirm.title')"
        @close="close"
        class="help-hide-confirm__header"
      data-testid="components-help-popover-help-hide-confirm-modal-modal-header" />
      <p class="help-hide-confirm__text" data-testid="components-help-popover-help-hide-confirm-modal-p">
        {{ t('help_popover.hide_confirm.text1') }}
      </p>
      <!-- <p class="help-hide-confirm__text">
        {{ t('help_popover.hide_confirm.text2') }}
      </p> -->
      <div class="help-hide-confirm__footer" data-testid="components-help-popover-help-hide-confirm-modal-div-2">
        <SkModalActionButton
          variant="cancel"
          height="38px"
          width="100%"
          class="help-hide-confirm__btn"
          @click="close"
         data-testid="components-help-popover-help-hide-confirm-modal-sk-modal-action-button">
          {{ t('help_popover.hide_confirm.cancel') }}
        </SkModalActionButton>
        <SkModalActionButton
          variant="danger"
          height="38px"
          width="100%"
          class="help-hide-confirm__btn help-hide-confirm__btn--confirm"
          @click="onConfirm"
         data-testid="components-help-popover-help-hide-confirm-modal-sk-modal-action-button-2">
          {{ t('help_popover.hide_confirm.confirm') }}
        </SkModalActionButton>
      </div>
    </div>
  </UiDialog>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import UiDialog from '@/components/ui/dialog.vue';
import ModalHeader from '@/components/modals/components/header.vue';
import SkModalActionButton from '@/components/ui-new/SkModalActionButton.vue';

defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:modelValue', 'confirm']);

const { t } = useI18n();

const close = () => {
  emit('update:modelValue', false);
};

const onConfirm = () => {
  emit('confirm');
};
</script>

<style scoped lang="scss">
.help-hide-confirm {
  padding: 15px;
  background: #fff;
  border-radius: 12px;
}
:deep(.modal-header__title) {
  font-size: 26px;
  font-weight: 600;
  }

.help-hide-confirm__text {
  padding: 0 0 25px;
  font-size: 14px;
  font-weight: 400;
  color: #00000099;
  line-height: 22px;

  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 1px;
    top: 55px;
    left: 0;
    display: block;
    background: #0000000D;
  }
   &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 1px;
    top: 112px;
    left: 0;
    display: block;
    background: #0000000D;
   }
}

.help-hide-confirm__footer {
  display: flex;
  align-items: stretch;
  width: 100%;
  gap: 12px;
}


</style>